import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';

import { ContentConfigOption } from '../content-config-option';
import { ContentConfig } from '../content-config';

@Component({
  selector: 'content-configure-dialog',
  template: `<div class="modal__content">
  <div class="modal__header">
    <h3>Configure Content</h3>
  </div>
  <div class="modal__body">
    <content-configure-form
      [config]="config"
      [options]="options"
      (onSubmit)="done($event)"
      (onCancel)="done($event)">
    </content-configure-form>
  </div>
</div>`,
  styles: [``]
})
export class ConfigureContentContainerDialogComponent {
  private _config: ContentConfig;
  public get config(): ContentConfig { return this._config; }
  
  private _options: ContentConfigOption[] = [];
  public get options(): ContentConfigOption[] { return this._options; }

  constructor(
    public dialogRef: MatDialogRef<ConfigureContentContainerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._config = data.config || new ContentConfig();
    this._options = data.options || [];
  }

  public done(config: ContentConfig): void {
    this.dialogRef.close(config);
  }

}
